import GR from "../../images/testimonials/GR.png";
import quote from "../../images/quote.svg";
import play from "../../images/testimonials/play.svg";

const TestimonialsHeader = ({ onWatchFullVideoClick }) => {
  return (
    <header id="testimonialsHeader">
      <div className="container">
        <img src={GR} alt="gr8-appers-header-image" className="gr-img" />
        <div className="content">
          <img src={quote} alt="quote" className="quote-img" />
          
          <h1>Every person holds a unique gift, <b>hidden until it's revealed.</b> <small>— Sunil GR</small></h1>
          <div className="button hallow-white-button" onClick={() => onWatchFullVideoClick("http://www.youtube.com/watch?v=YZnJjGi5Bzg")}>
            <img src={play} alt="play" className="play-img" /> Watch Full Video
          </div>
        </div>
      </div>
    </header>
  );
};

export default TestimonialsHeader;